//
import _ from 'lodash';

import { simplApi } from '../../api/simplApi';

import { receiveProject } from './project';
import { receiveFile } from './file';
import { receivePerson } from './person';
import { receiveStaff } from './staff';
import { receiveActivity } from './activity';
import { receiveCompany } from './company';
import { receiveTask } from './task';
import { receiveNote } from './note';
import { receiveServiceKey } from './servicekey';
import { receiveServiceType } from './servicetype';
import { receiveNumberRange } from './numberrange';
import handleApiError from '../../helpers/handleApiError';
import { fetchLimits } from './limits';
import { addFeedback } from './feedback';
// import { receiveNotification } from './notification';

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_TOTALDATA = 'REQUEST_TOTALDATA';
export const RECEIVE_TOTALDATA = 'RECEIVE_TOTALDATA';
export const SET_TOTALDATA = 'SET_TOTALDATA';
export const REQUEST_HISTORY = 'REQUEST_HISTORY';
export const RECEIVE_HISTORY = 'RECEIVE_HISTORY';
export const SET_HISTORY = 'SET_HISTORY';

// ------------------------------------
// Actions
// ------------------------------------

export function requestTotalData() {
  return {
    type: REQUEST_TOTALDATA,
  };
}

export function receiveTotalData(totalData) {
  return {
    type: RECEIVE_TOTALDATA,
    payload: {
      totalData,
    },
  };
}

export function requestHistory() {
  return {
    type: REQUEST_HISTORY,
  };
}

export function receiveHistory(history) {
  return {
    type: RECEIVE_HISTORY,
    payload: {
      history,
    },
  };
}

export const fetchHistory = () => dispatch => {
  dispatch(requestHistory());

  simplApi('history/')
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(receiveHistory(json.data));
      }
    });
};

export const fetchTotalData = () => dispatch => {
  dispatch(requestTotalData());
  dispatch(fetchHistory());

  simplApi('all/')
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(receiveActivity(json.activities));
        dispatch(receiveCompany(json.companies));
        dispatch(receiveProject(json.projects));
        dispatch(receiveFile(json.files));
        dispatch(receiveStaff(json.staff));
        dispatch(receivePerson(json.persons));
        dispatch(receiveTask(json.tasks));
        dispatch(receiveNote(json.notes));
        dispatch(receiveServiceKey(json.serviceKeys));
        dispatch(receiveServiceType(json.serviceTypes));
        dispatch(receiveNumberRange(json.numberRanges));
        // dispatch(receiveNotification(json.notification));

        dispatch(receiveTotalData());

        dispatch(requestHistory());
        dispatch(fetchLimits());
      }
    });
};

export const restoreObject = (type, id) => dispatch => {
  const url = `restore/${type}/${id}`;
  const options = { method: 'post' };

  // console.log('restoring!', type, id);

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(addFeedback('success', 'Erfolgreich wiederhergestellt.'));
        dispatch(fetchTotalData());
      }
    });
};

export const actions = {
  requestTotalData,
  receiveTotalData,
  fetchTotalData,
  requestHistory,
  receiveHistory,
  fetchHistory,
  restoreObject,
};

const TOTALDATA_ACTION_HANDLERS = {
  [REQUEST_TOTALDATA]: state => ({ ...state, fetching: true }),
  [RECEIVE_TOTALDATA]: state => ({
    ...state,
    fetching: false,
  }),
  [RECEIVE_HISTORY]: (state, action) => {
    const stateHistory = state.history;

    _.forOwn(action.payload.history, (_history, id) => {
      const newHistory = _history;

      if (typeof stateHistory[id] === 'object') {
        Object.assign(stateHistory[id], stateHistory[id], newHistory);
      } else {
        stateHistory[id] = newHistory;
      }
    });

    return {
      ...state,
      history: stateHistory,
      fetching: false,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  fetching: false,
  lastUpdate: null,
  lastCache: null,
  history: {},
};

export default function activityReducer(state = initialState, action) {
  const handler = TOTALDATA_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/totaldata.js